<template>
  <div>
    <!-- catCodeDetail -->
    <catCode-detail v-bind:catCodeString="this.$route.params.catCodeString"  title="CatCode" />

    <!-- Graph of the snapshot pricing and availability  -->
    <PriceHistoryGraph v-bind:catCodeString="this.$route.params.catCodeString" title="Snapshots" />

    <!-- Other/Vendor list items with this catCode  -->
    <vendor-list-items v-bind:catCodeString="this.$route.params.catCodeString" />

    <!-- All Snapshots attached to this catCode  -->
    <snapshot-list v-bind:catCodeString="this.$route.params.catCodeString" title="Snapshots" />
  </div>
</template>

<script>
    // Components
    import CatCodeDetail from '../components/catCodes/catCode-detail.vue';
    import SnapshotList from '../components/snapshots/snapshot-list.vue';

    import {CatCodesService} from '../services/api/catCodes';
    const apiCatCodes = new CatCodesService();

    export default {
      components: {
        CatCodeDetail,
        SnapshotList,
        VendorListItems: () => import("@/components/catCodes/vendor-list-items.vue"),
        PriceHistoryGraph: () => import("@/components/catCodes/PriceHistoryGraph.vue") 
      },

      data () {
        return {}
      },
    }
</script>